<template>
  <v-dialog
    max-width="500px"
    v-model="entityEditDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown || entityEditData.resource.fullscreenEditDialog"
    :hide-overlay="entityEditData.resource.fullscreenEditDialog"
    transition="dialog-bottom-transition"
    persistent
  >
    <v-card>
      <v-toolbar
        dark
        flat
        color="secondary"
        :fixed="entityEditData.resource.fullscreenEditDialog"
      >
        <v-btn
          icon
          dark
          @click.native="cancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ entityEditData.resource.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-2"
          depressed
          large
          :loading="saving"
          :disabled="saving"
          @click="save"
          v-shortkey="{win: ['cntl', 's'], mac: ['meta', 's']}"
          @shortkey="save"
        >
          שמירה
        </v-btn>
      </v-toolbar>
      <v-card-text :class="{ 'mt-5 pa-4': entityEditData.resource.fullscreenEditDialog }">
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <div
            v-for="(f, index) in fields"
            :key="`f${index}`"
          >
            <template v-if="isItemVisible(f)">
              <!-- <v-col> -->
              <!-- Text -->
              <v-text-field
                v-if="f.type === 'TEXT'"
                :rules="f.validationRules"
                :dir="f.ltr ? 'ltr' : 'rtl'"
                :required="f.required"
                v-model="editableResource[f.field]"
                :append-icon="f.icon"
                :label="`${f.name}${f.required ? '*' : ''}`"
                height="42px"
                :hint="f.hint"
                autocomplete="off"
              ></v-text-field>

              <!-- Number -->
              <v-text-field
                v-else-if="f.type === 'NUMBER'"
                :rules="f.validationRules"
                :dir="f.ltr ? 'ltr' : 'rtl'"
                :required="f.required"
                v-model="editableResource[f.field]"
                :append-icon="f.icon"
                :label="`${f.name}${f.required ? '*' : ''}`"
                height="42px"
                type="number"
                :hint="f.hint"
                autocomplete="off"
              ></v-text-field>

              <!-- Textarea -->
              <v-textarea
                v-else-if="f.type === 'TEXTAREA'"
                :rules="f.validationRules"
                :dir="f.ltr ? 'ltr' : 'rtl'"
                :required="f.required"
                v-model="editableResource[f.field]"
                :label="`${f.name}${f.required ? '*' : ''}`"
                :rows="entityEditData.resource.fullscreenEditDialog ? 12 : 3"
                auto-grow
                :hint="f.hint"
                autocomplete="off"
              ></v-textarea>

              <!-- Date -->
              <v-text-field
                v-else-if="f.type === 'DATE'"
                v-model="editableResource[f.field]"
                :append-icon="f.icon"
                :label="`${f.name}${f.required ? '*' : ''}`"
                height="42px"
                type="date"
                autocomplete="off"
              ></v-text-field>

              <!-- DateTime -->
              <v-text-field
                v-else-if="f.type === 'DATETIME'"
                v-model="editableResource[f.field]"
                :append-icon="f.icon"
                :label="`${f.name}${f.required ? '*' : ''}`"
                height="42px"
                type="datetime-local"
                :rules="f.validationRules"
                autocomplete="off"
              ></v-text-field>

              <!-- Color -->
              <color-picker
                v-else-if="f.type === 'COLOR'"
                v-model="editableResource[f.field]"
                :original-color="editableResource[f.field]"
              />

              <!-- Icon -->
              <v-text-field
                v-else-if="f.type === 'ICON'"
                :rules="f.validationRules"
                :dir="f.ltr ? 'ltr' : 'rtl'"
                :required="f.required"
                v-model="editableResource[f.field]"
                :append-icon="f.icon"
                :label="`${f.name}${f.required ? '*' : ''}`"
                height="42px"
                autocomplete="off"
              ></v-text-field>

              <!-- Icon -->
              <v-text-field
                v-else-if="f.type === 'IMAGE'"
                :rules="f.validationRules"
                :dir="f.ltr ? 'ltr' : 'rtl'"
                :required="f.required"
                v-model="editableResource[f.field]"
                :append-icon="f.icon"
                :label="`${f.name}${f.required ? '*' : ''}`"
                height="42px"
                autocomplete="off"
              ></v-text-field>

              <!-- Boolean -->
              <v-checkbox
                color="primary"
                v-else-if="f.type === 'BOOLEAN'"
                :label="f.name"
                :rules="f.validationRules"
                v-model="editableResource[f.field]"
              ></v-checkbox>
              <!-- <v-text-field v-else-if="f.type === 'BOOLEAN'" v-model="editableResource[f.field]" :label="`${f.name}${f.required ? '*' : ''}`" height="42px"></v-text-field> -->

              <!-- SELECT -->
              <v-autocomplete
                v-else-if="f.type === 'SELECT'"
                v-model="editableResource[f.field]"
                :items="getItems({ itemsGetter: f.itemsGetter, entitiesType: f.items })"
                :item-text="f.itemText"
                :item-value="f.itemValue"
                :return-object="false"
                :label="`${f.name}${f.required ? '*' : ''}`"
                :rules="f.validationRules"
                :multiple="f.isMultiple"
                chips
                autocomplete="off"
              >
                <template
                  slot="selection"
                  slot-scope="{ item, index }"
                >
                  <v-chip v-if="index <= (f.aggregateFrom - 1 || 0)">
                    <span>{{ item[f.itemText] }}</span>
                  </v-chip>
                  <span
                    v-if="index === (f.aggregateFrom || 1)"
                    class="grey--text caption"
                  >(+{{ editableResource[f.field].length - (f.aggregateFrom || 1) }})</span>
                </template>
              </v-autocomplete>

              <span v-else>{{ f }}</span>
              <!-- </v-col> -->
            </template>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions
        v-if="entityEditData.resource.fullscreenEditDialog"
        class="pa-4"
      >
        <v-btn
          color="secondary"
          :loading="saving"
          :disabled="saving"
          @click="save"
        >שמירה</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ColorPicker from "./ColorPicker.vue";
import { format } from "date-fns";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      saving: false,
      valid: true
    };
  },

  computed: {
    ...mapState({
      entityEditData: state => state.entityEditData
    }),
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    editableResource() {
      return this.$store.state.editableEntities[
        this.entityEditData.resource.entityType
      ][this.entityEditData.id];
    },
    fields() {
      let fields = [];
      let model = this.entityEditData.resource.model;
      for (let key of Object.keys(model)) {
        fields.push(
          Object.assign(
            {},
            {
              field: key
            },
            model[key]
          )
        );
      }
      return fields;
    },
    updatedResource() {
      let updatedResource = { _id: this.editableResource._id };
      for (let field of this.fields) {
        if (field.type === "DATETIME") {
          updatedResource[field.field] = new Date(
            this.editableResource[field.field]
          );
        } else if (field.type === "BOOLEAN") {
          updatedResource[field.field] = this.editableResource[field.field] ? true : false;
        } else {
          updatedResource[field.field] = this.editableResource[field.field];
        }
      }
      return updatedResource;
    }
  },

  methods: {
    isItemVisible(item) {
      let isHiddenField = item.type == "HIDDEN";
      let shouldShow = true;
      if (item.viewIf) {
        shouldShow = item.viewIf(this.editableResource, this.$store);
        if(!shouldShow) {
          // ...
        }
      }
      return !isHiddenField && shouldShow;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("CLEAR_CACHE")
          .then(() => {
            let entity, schema, listSchema, entityId, entityType, url, isNew;
            if (this.entityEditData.mainId) {
              url = this.entityEditData.mainResource.endpoint;
              entityType = this.entityEditData.mainResource.entityType;
              schema = this.entityEditData.mainResource.schema;
              listSchema = this.entityEditData.mainResource.listSchema;
              entityId = this.entityEditData.mainId;
              entity = this.$store.state.editableEntities[
                this.entityEditData.mainResource.entityType
              ][this.entityEditData.mainId];
              isNew = false;
            } else {
              url = this.entityEditData.resource.endpoint;
              entityType = this.entityEditData.resource.entityType;
              schema = this.entityEditData.resource.schema;
              listSchema = this.entityEditData.resource.listSchema;
              entityId = this.editableResource._id;
              entity = this.updatedResource;
              isNew = this.entityEditData.isNew;
            }
            return this.$store.dispatch("SAVE_ENTITY", {
              url,
              entityType,
              schema,
              listSchema,
              entityId,
              entity,
              isNew
            });
          })
          .then(() => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: this.entityEditData.resource.name + " נשמר/ה",
              color: "success"
            });

            //redirect after task created
            let redirectTo = this.entityEditData.resource.redirectTo;
            let redirectOnlyFrom = this.entityEditData.resource.redirectOnlyFrom;
              if (redirectTo && redirectOnlyFrom.includes(this.$router.currentRoute.name)) {
              this.$router.push(redirectTo + '/' + this.editableResource._id);
            }
          })
          .catch(err => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.response ? err.response.data.message : err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.saving = false;
            this.entityEditDialog = false;
            this.$store.commit("REMOVE_EDITABLE_ENTITIES");
          });
      }
    },
    cancel() {
      this.$store.commit("REMOVE_EDITABLE_ENTITIES");
      this.entityEditDialog = false;
    },
    getItems({ itemsGetter, entitiesType }) {
      let items = [];

      if (entitiesType) {
        if (this.$store.state.entities[entitiesType]) {
          items = Object.values(this.$store.state.entities[entitiesType]);
        }
      } else if (itemsGetter) {
        if (Array.isArray(this.editableResource[itemsGetter.depandsOn])) {
          for (let depanded of this.editableResource[itemsGetter.depandsOn]) {
            if (depanded) {
              items = items.concat(
                Object.values(
                  this.$store.getters[itemsGetter.getter](
                    depanded._id || depanded
                  )
                )
              );
            }
          }
        } else {
          let depanded = this.editableResource[itemsGetter.depandsOn];
          if (depanded) {
            items = Object.values(
              this.$store.getters[itemsGetter.getter](depanded._id || depanded)
            );
          }
        }
      }

      if (Array.isArray(items) && items.length) {
        items = items.sort((a, b) => {
          return (b.order || 0) - (a.order || 0);
        });
      }
      return items;
    }
  },

  props: [],

  components: {
    ColorPicker
  },

  beforeMount() {
    for (let f of this.fields) {
      if (f.type === "DATE") {
        if (this.editableResource[f.field]) {
          this.editableResource[f.field] = format(
            new Date(this.editableResource[f.field]),
            "YYYY-MM-DD"
          );
        }
      }
      if (f.type === "DATETIME") {
        if (this.editableResource[f.field]) {
          this.editableResource[f.field] =
            format(new Date(this.editableResource[f.field]), "YYYY-MM-DD") +
            "T" +
            format(new Date(this.editableResource[f.field]), "HH:mm");
        }
      }
    }
  },

  watch: {}
};
</script>

<style>
</style>
